import helper from "./helper";

export const request = params => {
  if (typeof params === "string") {
    let [method, url] = params.split(" ");
    return p =>
      helper.request({
        method,
        url,
        params: method.toUpperCase() === "GET" ? p : {},
        data: method.toUpperCase() !== "GET" ? p : null
      });
  }
  return helper.request(params);
};

export function bindUrl(url) {
  return "/api" + url;
}

// export function bindUrl(path, pathParams) {
//   if (!path.match(/^\//)) {
//     path = "/" + path;
//   }
//   var url = path;
//   url = url.replace(/\{([\w-]+)\}/g, function(fullMatch, key) {
//     var value;
//     if (pathParams.hasOwnProperty(key)) {
//       value = pathParams[key];
//     } else {
//       value = fullMatch;
//     }
//     return encodeURIComponent(value);
//   });
//   return url;
// }
